import * as React from 'react';
import StaticPage from '../../../containers/StaticPage';
import RoutesUtils from '../../../utils/routes';

interface StaticPageRouterProps {
	isGalleryLoaded: boolean;
	needsConnection: boolean;
	hasFetchError: boolean;
	isNotComponent: boolean;
	component: string | undefined;
}

const StaticPageRouter = ({
	isGalleryLoaded,
	needsConnection,
	hasFetchError,
	isNotComponent,
	component,
}: StaticPageRouterProps) => {
	React.useEffect(() => {
		if (needsConnection || hasFetchError || isNotComponent) {
			RoutesUtils.getPageNotFound();
			return;
		}
	}, [needsConnection, hasFetchError, isNotComponent]);

	const isNotOpenable = !isGalleryLoaded
		|| needsConnection
		|| hasFetchError
		|| isNotComponent;

	if (isNotOpenable || !component) {
		return null;
	}

	return (
		<StaticPage componentId={parseInt(component, 10)} />
	);
};

export default StaticPageRouter;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/StaticPage/Router/index.tsx